
import CardProductsinitial from "../components/cardProducts-initial/CardProductsInitComponent.vue";
import InfoModulo from "../components/infoModulo/ModuloSecaoComponent.vue";
import { defineComponent } from "vue";
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import CardProducts from "@/components/cardProducts-initial/CardProducts.vue";
import CardProductsMultiple from "@/components/cardProducts-initial/CardProductsMultiple.vue";
import { useRouter } from 'vue-router';
import { reactive } from 'vue';
import { useDisplay } from "vuetify";

export default defineComponent({
  methods: {useDisplay},
  components: {
    CardProductsMultiple,
    CardProducts,
    CardProductsinitial,
    InfoModulo,
  },
  setup() {
    function changeColor(element: string){
      return element === 'myCustomDarkTheme' ? 'changeColorToWhite' : 'changeColorToNormal'
    }

    const router = useRouter();
    function goToContact() {
      router.push("/contato");
    }

    const state = reactive({
      toggle: false,
      icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
          mdi,
        }
      },
    });
    return {
      goToContact,
      changeColor,
      state
    };
  },
});
